"use strict";

var React = require('react');

var _require = require('react-dom/server'),
    renderToStaticMarkup = _require.renderToStaticMarkup;

var printingPlus = require('./printingPlus');

var pistachioPress = require('./pistachioPress');

var users = require('../../config/users.json');

var templates = {
  printingPlus: printingPlus,
  pistachioPress: pistachioPress
};

function generateStaticMarkupReact(_ref) {
  var order = _ref.order,
      printJobs = _ref.printJobs,
      shipments = _ref.shipments,
      senderId = _ref.senderId,
      printerName = _ref.printerName,
      templateName = _ref.templateName,
      options = _ref.options;
  var EmailTemplate = templates[printerName][templateName];
  var user = users[senderId];
  var props = {
    order: order,
    user: user,
    options: options,
    PrintJobs: Array.isArray(printJobs) ? printJobs : [printJobs],
    Shipments: Array.isArray(shipments) ? shipments : [shipments]
  };
  return renderToStaticMarkup( /*#__PURE__*/React.createElement(EmailTemplate, props));
}

module.exports = generateStaticMarkupReact;